export const checksums = {
  "apartments_en": "v3.5.0--AfKkyzvhoa0NCvFQKto-EWLqJmfwb1fvba2_p5mh0pk",
  "apartments_ru": "v3.5.0--VLzV7lo0Uy5ERYoWDaRfmDTc9cnllk9I1s36H9agDNk",
  "apartments_ka": "v3.5.0--Br7T8urTG2dC6vKs5II2W1qu6Rbp1dFqtWW3oPg0heg",
  "pages_en": "v3.5.0--Y65Pkc3JHmK8KV12CGe3peHSTZbHOU-tju2lTH-P8kM",
  "pages_ru": "v3.5.0--EqUWIS2OSydyb7_DRSI6Ae4t5R9y3OUg6t-flbOISuo",
  "pages_ka": "v3.5.0--Efwy4QoP2kLpkleQaNy--BSXIPUpKOiGIGvS1IoAlBc"
}
export const checksumsStructure = {
  "apartments_en": "C0w4394NiUj2-WW04CN2QC5ZMGf3mDFZMnVsOC_4U6M",
  "apartments_ru": "nyRdnLl0e6XjcvgN28TdZeL9NVoAKWn1elKMLh9he8M",
  "apartments_ka": "6FLHRe6HObVNOJx8tB7xXEWxTCwDICvEbgF7bPXskXM",
  "pages_en": "_dIDznHrPvWqB_22lIkYlrgllLi0awO8cwFqpPLpd9w",
  "pages_ru": "iL2VPqG4FFQ6B9hUBrbaOqiizRoUAOiemhwk8mjFyng",
  "pages_ka": "jO6j669PiYBA-8wilirmr1YwSyewnozeH1xy4z2Mygo"
}

export const tables = {
  "apartments_en": "_content_apartments_en",
  "apartments_ru": "_content_apartments_ru",
  "apartments_ka": "_content_apartments_ka",
  "pages_en": "_content_pages_en",
  "pages_ru": "_content_pages_ru",
  "pages_ka": "_content_pages_ka",
  "info": "_content_info"
}

export default {
  "apartments_en": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "amenities": "json",
      "area_sqm": "number",
      "body": "json",
      "building": "string",
      "capacity": "string",
      "cover_photo": "json",
      "description": "string",
      "editorial": "json",
      "extension": "string",
      "extra_bed_available": "boolean",
      "floor": "string",
      "hotel": "string",
      "keywords": "json",
      "last_updated": "json",
      "listing_id": "string",
      "living_sqm": "number",
      "meta": "json",
      "meta_description": "string",
      "navigation": "json",
      "path": "string",
      "photo_gallery": "json",
      "rooms": "string",
      "seo": "json",
      "seo_title": "string",
      "status": "string",
      "stem": "string",
      "terrace_sqm": "number",
      "view_details": "string",
      "view_type": "string",
      "weekly_includes": "json"
    }
  },
  "apartments_ru": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "amenities": "json",
      "area_sqm": "number",
      "body": "json",
      "building": "string",
      "capacity": "string",
      "cover_photo": "json",
      "description": "string",
      "editorial": "json",
      "extension": "string",
      "extra_bed_available": "boolean",
      "floor": "string",
      "hotel": "string",
      "keywords": "json",
      "last_updated": "json",
      "listing_id": "string",
      "living_sqm": "number",
      "meta": "json",
      "meta_description": "string",
      "navigation": "json",
      "path": "string",
      "photo_gallery": "json",
      "rooms": "string",
      "seo": "json",
      "seo_title": "string",
      "status": "string",
      "stem": "string",
      "terrace_sqm": "number",
      "view_details": "string",
      "view_type": "string",
      "weekly_includes": "json"
    }
  },
  "apartments_ka": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "amenities": "json",
      "area_sqm": "number",
      "body": "json",
      "building": "string",
      "capacity": "string",
      "cover_photo": "json",
      "description": "string",
      "editorial": "json",
      "extension": "string",
      "extra_bed_available": "boolean",
      "floor": "string",
      "hotel": "string",
      "keywords": "json",
      "last_updated": "json",
      "listing_id": "string",
      "living_sqm": "number",
      "meta": "json",
      "meta_description": "string",
      "navigation": "json",
      "path": "string",
      "photo_gallery": "json",
      "rooms": "string",
      "seo": "json",
      "seo_title": "string",
      "status": "string",
      "stem": "string",
      "terrace_sqm": "number",
      "view_details": "string",
      "view_type": "string",
      "weekly_includes": "json"
    }
  },
  "pages_en": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "activities": "json",
      "apartments_bridge": "json",
      "aquapark_pricing": "json",
      "aquapark_showcase": "json",
      "attractions_gallery": "json",
      "beach_showcase": "json",
      "body": "json",
      "coords": "json",
      "corners_gallery": "json",
      "description": "string",
      "distances": "json",
      "exceptional_block": "json",
      "extension": "string",
      "faq_block": "json",
      "further": "json",
      "grounds_showcase": "json",
      "hero_image": "string",
      "hero_image_alt": "string",
      "history_block": "json",
      "included": "json",
      "intro": "string",
      "ka_translation_pending": "boolean",
      "kids_zones": "json",
      "last_updated": "json",
      "location_teaser": "json",
      "meta": "json",
      "meta_description": "string",
      "navigation": "json",
      "oasis_section": "json",
      "og_image": "string",
      "parkland_block": "json",
      "path": "string",
      "pool_and_amenity_costs_updated": "string",
      "pool_pricing": "json",
      "pool_showcase": "json",
      "privacy_block": "json",
      "restaurants_showcase": "json",
      "rhythm_block": "json",
      "rules_detail": "json",
      "seasonal_guide": "json",
      "sections": "json",
      "seo": "json",
      "seo_title": "string",
      "service_cards": "json",
      "slug": "string",
      "stem": "string",
      "territory": "json",
      "transport_block": "json"
    }
  },
  "pages_ru": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "activities": "json",
      "apartments_bridge": "json",
      "aquapark_pricing": "json",
      "aquapark_showcase": "json",
      "attractions_gallery": "json",
      "beach_showcase": "json",
      "body": "json",
      "coords": "json",
      "corners_gallery": "json",
      "description": "string",
      "distances": "json",
      "exceptional_block": "json",
      "extension": "string",
      "faq_block": "json",
      "further": "json",
      "grounds_showcase": "json",
      "hero_image": "string",
      "hero_image_alt": "string",
      "history_block": "json",
      "included": "json",
      "intro": "string",
      "ka_translation_pending": "boolean",
      "kids_zones": "json",
      "last_updated": "json",
      "location_teaser": "json",
      "meta": "json",
      "meta_description": "string",
      "navigation": "json",
      "oasis_section": "json",
      "og_image": "string",
      "parkland_block": "json",
      "path": "string",
      "pool_and_amenity_costs_updated": "string",
      "pool_pricing": "json",
      "pool_showcase": "json",
      "privacy_block": "json",
      "restaurants_showcase": "json",
      "rhythm_block": "json",
      "rules_detail": "json",
      "seasonal_guide": "json",
      "sections": "json",
      "seo": "json",
      "seo_title": "string",
      "service_cards": "json",
      "slug": "string",
      "stem": "string",
      "territory": "json",
      "transport_block": "json"
    }
  },
  "pages_ka": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "activities": "json",
      "apartments_bridge": "json",
      "aquapark_pricing": "json",
      "aquapark_showcase": "json",
      "attractions_gallery": "json",
      "beach_showcase": "json",
      "body": "json",
      "coords": "json",
      "corners_gallery": "json",
      "description": "string",
      "distances": "json",
      "exceptional_block": "json",
      "extension": "string",
      "faq_block": "json",
      "further": "json",
      "grounds_showcase": "json",
      "hero_image": "string",
      "hero_image_alt": "string",
      "history_block": "json",
      "included": "json",
      "intro": "string",
      "ka_translation_pending": "boolean",
      "kids_zones": "json",
      "last_updated": "json",
      "location_teaser": "json",
      "meta": "json",
      "meta_description": "string",
      "navigation": "json",
      "oasis_section": "json",
      "og_image": "string",
      "parkland_block": "json",
      "path": "string",
      "pool_and_amenity_costs_updated": "string",
      "pool_pricing": "json",
      "pool_showcase": "json",
      "privacy_block": "json",
      "restaurants_showcase": "json",
      "rhythm_block": "json",
      "rules_detail": "json",
      "seasonal_guide": "json",
      "sections": "json",
      "seo": "json",
      "seo_title": "string",
      "service_cards": "json",
      "slug": "string",
      "stem": "string",
      "territory": "json",
      "transport_block": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}